import { styled } from '@mui/material/styles';
import StyledAgentImage from '../../styles/StyledAgentImage';

const StyledWelcomeAgentImage1 = styled(StyledAgentImage)`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 48%;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 220px;
    position: absolute;
    top: 35%;
    left: 2%;
    transform: translateY(-50%);
  }
`;

export default StyledWelcomeAgentImage1;
